export const endpoint = {
	base: "",
	templateId: "/:templateId",
} as const;
